// import React, { useEffect, useState } from 'react';
// import { Dropdown, Badge } from 'react-bootstrap';
// import { useSelector } from 'react-redux';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBell } from '@fortawesome/free-solid-svg-icons';
// import { fetchNotifications } from './../../hooks/notificationService';
// import './Header.css';

// const NotificationDropdown = () => {
//     const userID = useSelector((state) => state.user.user.UserID);
//     const [notifications, setNotifications] = useState([]);
//     const [unreadCount, setUnreadCount] = useState(0);

//     useEffect(() => {
//         const loadNotifications = async () => {
//             const data = await fetchNotifications(userID);
//             setNotifications(data);
//             setUnreadCount(data.filter(notification => !notification.IsRead).length);
//         };
//         loadNotifications();
//     }, [userID]);

//     const markAsRead = (id) => {
//         setNotifications((prev) =>
//             prev.map((notification) =>
//                 notification.ID === id ? { ...notification, IsRead: 1 } : notification
//             )
//         );
//         setUnreadCount((count) => Math.max(count - 1, 0));
//     };

//     return (
//         <Dropdown align="end">
//             <Dropdown.Toggle variant="light" id="dropdown-basic" className="notification-icon">
//                 <FontAwesomeIcon icon={faBell} className="bell-icon" />
//                 {unreadCount > 0 && (
//                     <Badge bg="danger" className="notification-badge">
//                         {unreadCount > 99 ? '99+' : unreadCount}
//                     </Badge>
//                 )}
//             </Dropdown.Toggle>
//             <Dropdown.Menu className="notification-menu">
//                 <Dropdown.Header>Notifications</Dropdown.Header>
//                 {notifications.length > 0 ? (
//                     notifications.map((notification) => (
//                         <Dropdown.Item
//                             key={notification.ID}
//                             onClick={() => markAsRead(notification.ID)}
//                             className={notification.IsRead ? 'notification-item' : 'notification-item unread'}
//                         >
//                             {notification.Message}
//                         </Dropdown.Item>
//                     ))
//                 ) : (
//                     <Dropdown.Item>No notifications</Dropdown.Item>
//                 )}
//             </Dropdown.Menu>
//         </Dropdown>
//     );
// };

// export default NotificationDropdown;
import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosConfig/instance";
import { useSelector } from 'react-redux';
import { fetchNotifications } from './../../hooks/notificationService';
import './Header.css';

export default function NotificationDropdown({ width = "24px", color = "#001D3D" }) {
  const [count, setCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        const data = await fetchNotifications(user);
        setNotifications(data);
        setCount(data.filter(notification => notification.ISRead === '0').length);
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      }
    };
    loadNotifications();
  }, [user]);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const markAsRead = async (notificationID) => {
    try {
      await axiosInstance.post(`notification/mark-as-read/${notificationID}`);
      setNotifications(prevNotifications =>
        prevNotifications.map(notification =>
          notification.ID === notificationID ? { ...notification, ISRead: '1' } : notification
        )
      );
      setCount(prevCount => Math.max(0, prevCount - 1));
    } catch (error) {
      console.error("Failed to mark notification as read:", error);
    }
  };

  return (
    <div className="notification-container">
      <div className="notification-icon" onClick={toggleDropdown}>
        {count > 0 && (
          <div className="notification-badge">
            {count > 99 ? "99+" : count}
          </div>
        )}
        <svg
          viewBox="0 0 24 24"
          className="notification-icon-svg"
          width={width}
          fill={color}
        >
          <g>
            <path d="M21.697 16.468c-.02-.016-2.14-1.64-2.103-6.03.02-2.532-.812-4.782-2.347-6.335C15.872 2.71 14.01 1.94 12.005 1.93h-.013c-2.004.01-3.866.78-5.242 2.174-1.534 1.553-2.368 3.802-2.346 6.334.037 4.33-2.02 5.967-2.102 6.03-.26.193-.366.53-.265.838.102.308.39.515.712.515h4.92c.102 2.31 1.997 4.16 4.33 4.16s4.226-1.85 4.327-4.16h4.922c.322 0 .61-.206.71-.514.103-.307-.003-.645-.263-.838zM12 20.478c-1.505 0-2.73-1.177-2.828-2.658h5.656c-.1 1.48-1.323 2.66-2.828 2.66zM4.38 16.32c.74-1.132 1.548-3.028 1.524-5.896-.018-2.16.644-3.982 1.913-5.267C8.91 4.05 10.397 3.437 12 3.43c1.603.008 3.087.62 4.18 1.728 1.27 1.285 1.933 3.106 1.915 5.267-.024 2.868.785 4.765 1.525 5.896H4.38z" />
          </g>
        </svg>
      </div>

      {dropdownVisible && (
        <div className="notification-dropdown">
          <h6>الاشعارات</h6>
          {notifications.length > 0 ? (
            notifications.map((notification, index) => (
              <div
                key={index}
                className={`notification-item ${notification.ISRead === '0' ? 'unread' : ''}`}
                // onClick={() => markAsRead(notification.ID)}
              >
                {notification.Content}
              </div>
            ))
          ) : (
            <div className="notification-empty">لا يوجد اشعارات</div>
          )}
        </div>
      )}
    </div>
  );
}
